import { NgModuleFactory, Type } from '@angular/core';

export interface Module {
  path: string;
  loadChildren: () => Promise<NgModuleFactory<any> | Type<any>>;
}

export const modules: Module[] = [];
